import React, { useState, useEffect } from 'react';
import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Alert,
  Snackbar,
  CircularProgress,
  Backdrop
} from '@mui/material';
import { GetMandateSummary, surreenderMandateId, SurrenderMandate } from 'API/Mandate_Surrender';
// import { IoMdArrowBack } from 'react-icons/io';
import LoadingButton from '@mui/lab/LoadingButton';

const AddSurrender = (props) => {
  const BankList = props.BankList;
  const [Error, setError] = useState(false);
  const [Isloading, setIsloading] = useState(false);
  const [SubIsloading, setSubIsloading] = useState(false);
  const [Success, setSuccess] = useState([]);
  const [SuccessMsg, setSuccessMsg] = useState(false);
  const [MandateDetails, setMandateDetails] = useState('');

  const [Data, setData] = useState({
    bank_name: '',
    mandate_id: '',
    // total_mandate: '',
    // mandate_used: '',
    // mandate_pending: '',
    remarks: ''
  });
  const [errors, setErrors] = useState({});

  const handleChange = (name, value) => {
    // setData({ ...Data, [name]: value });
    setData((prevData) => ({
      ...prevData,
      [name]: value
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '' // Remove error for this field
    }));
  };

  const validateForm = () => {
    let newErrors = {};

    Object.keys(Data).forEach((key) => {
      if (!Data[key]) {
        newErrors[key] = `${key.replace(/_/g, ' ')} is required`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // If no errors, return true
  };

  const handleSubmit = () => {
    if (validateForm()) {
      SurrenderMandate(Data, setSubIsloading, setSuccessMsg, setError, props.setSurrenderRequest, props.refunction);
      // Proceed with form submission
    }
  };

  useEffect(() => {
    if (Data.bank_name) {
      surreenderMandateId(Data.bank_name, setIsloading, setSuccess, setError);
    }
  }, [Data.bank_name]);

  useEffect(() => {
    if (Data.mandate_id) {
      GetMandateSummary(Data.mandate_id, setIsloading, setMandateDetails, setError);
    }
  }, [Data.mandate_id]);

  return (
    <>
      <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={Isloading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={SuccessMsg}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setSuccessMsg(false)}
      >
        <Alert onClose={() => setSuccessMsg(false)} severity="success" variant="filled" sx={{ width: '100%' }}>
          {SuccessMsg}
        </Alert>
      </Snackbar>
      <Snackbar
        open={Error}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={6000}
        onClose={() => setError(false)}
      >
        <Alert onClose={() => setError(false)} severity="error" variant="filled" sx={{ width: '100%' }}>
          {Error}
        </Alert>
      </Snackbar>
      {/* <Button sx={{ width: '20px' }} onClick={() => props.setSurrenderRequest(false)}>
        <IoMdArrowBack style={{ color: 'black', fontSize: '20px' }} />
      </Button> */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <FormControl required fullWidth variant="outlined" error={Boolean(errors.bank_name)}>
            <InputLabel>Bank name</InputLabel>
            <Select label="Select Bank" value={Data.bank_name} onChange={(e) => handleChange('bank_name', e.target.value)}>
              <MenuItem value={'select'} disabled>
                Select
              </MenuItem>
              {props.IsloadingBank && (
                <MenuItem value={'select'} disabled>
                  <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={props.IsloadingBank}>
                    <CircularProgress color="inherit" />
                  </Backdrop>
                </MenuItem>
              )}

              {BankList && BankList.length ? (
                BankList &&
                BankList?.map((bank, index) => (
                  <MenuItem value={bank.Bankname} key={index}>
                    {bank.Full_Bank_Name.toUpperCase()}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" sx={{ display: 'flex', justifyContent: 'center' }} disabled>
                  No bank found
                </MenuItem>
              )}
            </Select>
            {errors.bank_name && <FormHelperText>{errors.bank_name}</FormHelperText>}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <FormControl fullWidth variant="outlined">
            {/* <TextField
              required
              label="Mandate ID"
              value={Data.mandate_id}
              error={Boolean(errors.mandate_id)}
              helperText={errors.mandate_id}
              onChange={(e) => handleChange('mandate_id', e.target.value)}
            /> */}
            <FormControl required fullWidth variant="outlined" error={Boolean(errors.mandate_id)}>
              <InputLabel>Mandate ID</InputLabel>
              <Select
                label="Mandate ID"
                value={Data.mandate_id}
                inputProps={{
                  readOnly: !Data.bank_name
                }}
                onChange={(e) => handleChange('mandate_id', e.target.value)}
              >
                <MenuItem value={'select'} disabled>
                  Select
                </MenuItem>
                {Success && Success.length ? (
                  Success?.map((id, index) => (
                    <MenuItem value={id} key={index}>
                      {id}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="" sx={{ display: 'flex', justifyContent: 'center' }} disabled>
                    No Mandate ID found
                  </MenuItem>
                )}
              </Select>
              {errors.mandate_id && <FormHelperText>{errors.mandate_id}</FormHelperText>}
            </FormControl>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <FormControl fullWidth variant="outlined">
            <TextField
              required
              label="Total Mandate No."
              value={'' || MandateDetails.total_bcs_vacancy}
              // error={Boolean(errors.total_mandate)}
              // helperText={errors.total_mandate}
              inputProps={{
                readOnly: true
              }}
              InputLabelProps={{
                shrink: true
              }}
              // onChange={(e) => handleChange('total_mandate', e.target.value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <FormControl fullWidth variant="outlined">
            <TextField
              required
              label="Mandate used"
              value={'' || MandateDetails.total_completed}
              // error={Boolean(errors.mandate_used)}
              // helperText={errors.mandate_used}
              inputProps={{
                readOnly: true
              }}
              InputLabelProps={{
                shrink: true
              }}
              // onChange={(e) => handleChange('mandate_used', e.target.value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <FormControl fullWidth variant="outlined">
            <TextField
              required
              label="Mandate pending"
              // value={''||(MandateDetails.total_bcs_vacancy - MandateDetails.total_completed) - MandateDetails.total_in_progress
              // }
              value={
                (MandateDetails?.total_bcs_vacancy || 0) - (MandateDetails?.total_completed || 0) - (MandateDetails?.total_in_progress || 0)
              }
              // error={Boolean(errors.mandate_pending)}
              // helperText={errors.mandate_pending}
              inputProps={{
                readOnly: true
              }}
              InputLabelProps={{
                shrink: true
              }}
              // onChange={(e) => handleChange('mandate_pending', e.target.value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={8}>
          <FormControl fullWidth variant="outlined">
            <TextField
              required
              label="Remarks"
              multiline
              rows={6}
              value={Data.remarks}
              error={Boolean(errors.remarks)}
              helperText={errors.remarks}
              onChange={(e) => handleChange('remarks', e.target.value)}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container mt={2} display={'flex'} justifyContent={'center'}>
        <Button
          color="secondary"
          variant="outlined"
          onClick={() => props.setSurrenderRequest(false)}
          sx={{
            width: '25%',
            borderColor: '#592375',
            color: '#592375',
            mr: 1,
            borderRadius: '6px',
            '&:hover': {
              borderColor: '#592375'
            }
          }}
        >
          back
        </Button>
        <LoadingButton
          loading={SubIsloading}
          sx={{
            width: '25%',
            backgroundColor: '#592375',
            color: '#FFFFFF',
            borderRadius: '6px',
            '&:hover': {
              backgroundColor: '#592375'
            }
          }}
          color="secondary"
          variant="contained"
          onClick={handleSubmit}
        >
          submit
        </LoadingButton>
      </Grid>
    </>
  );
};

export default AddSurrender;
